export const TEST_IDS = {
  VIDEO: 'media-video',
  AUDIO_TOGGLE: 'media-video-audio-toggle',
} as const;
